module.exports = __webpack_public_path__ + "static/img/share_offical.f4d5e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_offical.png
// module id = WlL5
// module chunks = 1